import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachProductsPromoCodesPage } from "src/pages/CoachProductsPromoCodesPage";
import {
  productOptionsQueryOptions,
  promoCodesQueryOptions,
} from "src/queries/products";

export const Route = createFileRoute(
  "/_auth/_coach/products/_tabs/promo-codes",
)({
  component: CoachProductsPromoCodesPage,
  ssr: true,
  async loader({ context }) {
    return loaderHandler(async ({ session }) => {
      if (session?.user.stripeAccountStatus !== "NOT_CONNECTED") {
        await Promise.all([
          context.queryClient.infiniteQuery({
            ...promoCodesQueryOptions(),
            staleTime: "static",
          }),
          context.queryClient.query({
            ...productOptionsQueryOptions(),
            staleTime: "static",
          }),
        ]);
      }

      return { data: null };
    });
  },
});
